export default [

     {
          path: '/diarequest',
          name: 'DIARequest',
          component: () => import("@/views/Page/DIARequest/DIARequest.vue"),
           meta: {
               title: '#Default# | DIARequest',
          },
     }
];